import { render, staticRenderFns } from "./finance-syrz-details.vue?vue&type=template&id=e0060326&scoped=true&"
import script from "./finance-syrz-details.vue?vue&type=script&lang=js&"
export * from "./finance-syrz-details.vue?vue&type=script&lang=js&"
import style0 from "./finance-syrz-details.vue?vue&type=style&index=0&id=e0060326&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0060326",
  null
  
)

export default component.exports